import { useCallback, useMemo, useState } from "react";
import { Airframe } from "../../../../types/airframe";

export function useAirframeFilter(airframes: Airframe[]) {
  const [operatorFilters, setOperatorFilters] = useState<Set<string>>(
    () => new Set()
  );

  const toggleOperatorFilter = useCallback((id: string) => {
    setOperatorFilters((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, []);

  const clearOperatorFilters = useCallback(() => {
    setOperatorFilters(new Set());
  }, []);

  const filteredAirframes = useMemo(() => {
    if (operatorFilters.size === 0) return airframes;

    return airframes.filter(
      (a) => a.operatorId != null && operatorFilters.has(a.operatorId)
    );
  }, [airframes, operatorFilters]);

  return {
    filteredAirframes,
    operatorFilters,
    toggleOperatorFilter,
    clearOperatorFilters,
  };
}
